var _rect, _rect2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReservation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.678571,
    y: 0.678571,
    width: 46.6429,
    height: 46.6429,
    rx: 23.3214,
    fill: "#37BB90"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.678571,
    y: 0.678571,
    width: 46.6429,
    height: 46.6429,
    rx: 23.3214,
    stroke: "white",
    strokeWidth: 1.35714
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6906 32.9438C39.4114 33.0352 40.0915 32.5956 40.2805 31.9165L40.2852 31.4084C40.2578 31.3298 40.2351 31.2494 40.2172 31.168C40.0713 30.2991 39.9253 29.4305 39.7792 28.5618C39.6329 27.6917 39.4866 26.8217 39.3405 25.9514C38.7973 22.7453 38.2588 19.5384 37.726 16.3305C37.7251 16.2812 37.7223 16.2327 37.7156 16.1843C37.6231 15.4687 36.9495 14.9615 36.2098 15.051H11.667L14.6711 32.9365H15.1037C22.9663 32.9283 30.828 32.931 38.6906 32.9438ZM7.85971 30.7228C7.81108 30.9512 7.76247 31.1795 7.71484 31.408V31.9161C7.93078 32.6116 8.73513 33.0549 9.57404 32.9415C10.4553 32.9205 11.3376 32.9253 12.2198 32.9301C12.6001 32.9321 12.9803 32.9342 13.3605 32.9342H13.8625L10.7012 16.4672C10.6278 16.5448 10.5825 16.6381 10.5695 16.7368L9.92169 20.079C9.33759 23.1415 8.75133 26.2023 8.16075 29.263C8.06672 29.7505 7.9632 30.2367 7.85971 30.7228Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2885 18.701L23.9289 26.8167L19.6802 23.1705C19.3837 22.9139 18.9323 22.9475 18.6716 23.2463C18.5473 23.3914 18.4873 23.5758 18.5023 23.7667C18.5173 23.9575 18.6051 24.1305 18.7501 24.2549L23.4932 28.3277C23.6232 28.4385 23.7882 28.5 23.9582 28.5C24.1453 28.5 24.3218 28.4285 24.4561 28.2984L33.2843 19.7267C33.5664 19.4522 33.5722 18.999 33.2993 18.7174C33.0271 18.4343 32.5757 18.4265 32.2885 18.701Z",
    fill: "#37BB90",
    stroke: "#37BB90",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservation);
export default __webpack_public_path__ + "static/media/reservation.ad0ea7f25e1158063e7906d4ddcfacc5.svg";
export { ForwardRef as ReactComponent };